//DOCS
//https://element.eleme.io/#/en-US

import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/pt-br'

Vue.use(ElementUI, { locale })
